import fb1 from '../../assets/fb/fb1.jpg';
import fb1M from '../../assets/fb/fb1M.jpg';
import fb2 from '../../assets/fb/fb2.jpg';
import fb2M from '../../assets/fb/fb2M.jpg';
import fb3 from '../../assets/fb/fb3.jpg';
import fb3M from '../../assets/fb/fb3M.jpg';

export const photoContents = [
  { desktop: fb1, mobile: fb1M },
  { desktop: fb2, mobile: fb2M },
  { desktop: fb3, mobile: fb3M }
];
